import { GraphData } from "../Editor/Displays/Graph";
import { plotFunction } from "../Editor/Displays/PlotFunction";


export function loadGraph(item:HTMLElement, data:GraphData){
    const id = item.id;
    plotFunction(data, "#" + id);
}